// extracted by mini-css-extract-plugin
export default {"icon":"UserRolesPage_icon__5pzHU","user_field":"UserRolesPage_user_field__VfnwK","empty":"UserRolesPage_empty__ooCJb"};